import { ReactNode } from 'react';
import { components } from '@api/play-account/generated';

import { CapsuleButton } from '@ui/components/CapsuleButton';
import { DateRangeInput } from '@ui/components/DateRangeInput/DateRangeInput';
import { HeavyModalCard } from '@ui/components/HeavyModalCard/HeavyModalCard';
import { Placeholder } from '@ui/components/Placeholder/Placeholder';
import { ClockControlIcon } from '@ui/icons/ClockControlIcon';

import { ClockControlType } from '@features/shared/api/typings';
import { TIME_CONTROL } from '@features/shared/constants';
import { PlayerGamesList } from '@features/user/ui/PlayerGamesList/PlayerGamesList';

import styles from './PlayerGamesListFull.module.css';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  games?: components['schemas']['UserGameHistoryItemDto'][];
  hasNextPage: boolean;
  fetchNextPage: () => void;
  clockControlType: ClockControlType;
  rank?: number;
  gameCount?: number;
  dateRange: {
    start: Date | null;
    end: Date | null;
  };
  onDateRangeChange: (value: { start: Date | null; end: Date | null }) => void;
  onDownloadPgn: (gameId: string) => void;
  onGameClick: (game: components['schemas']['UserGameHistoryItemDto']) => void;
  renderShieldQuickPeek: (userId: string) => ReactNode;
  opponentAvgRank?: number | null;
};
export function PlayerGamesListFull({
  games,
  isOpen,
  onClose,
  hasNextPage,
  fetchNextPage,
  clockControlType,
  rank,
  gameCount,
  dateRange,
  onDateRangeChange,
  onDownloadPgn,
  onGameClick,
  renderShieldQuickPeek,
  opponentAvgRank,
}: Props) {
  return (
    <HeavyModalCard
      header={<ModalHeader clockControlType={clockControlType} rank={rank} />}
      open={isOpen}
      onBack={onClose}
    >
      <div className={styles.content}>
        <div className={styles.dataRow}>
          <div className={styles.label}>Игр</div>
          <div className={styles.filler} />
          <div className={styles.data}>{gameCount}</div>
        </div>
        <div className={styles.dataRow}>
          <div className={styles.label}>Сред. рейтинг оппонентов</div>
          <div className={styles.filler} />
          <div className={styles.data}>{opponentAvgRank}</div>
        </div>

        <div className={styles.dataRow}>
          <DateRangeInput
            className={styles.dateRangeInput}
            preset="heavy"
            value={dateRange}
            onChange={onDateRangeChange}
          />
        </div>

        {games && games.length > 0 && (
          <PlayerGamesList
            className={styles.list}
            games={games}
            onDownloadPgn={onDownloadPgn}
            onGameClick={onGameClick}
            renderShieldQuickPeek={renderShieldQuickPeek}
          />
        )}

        {games && games.length === 0 && (
          <Placeholder className={styles.placeholder}>Нет игр</Placeholder>
        )}

        {hasNextPage && (
          <CapsuleButton preset="hollow-golden" onClick={fetchNextPage}>
            Показать еще
          </CapsuleButton>
        )}
      </div>
    </HeavyModalCard>
  );
}

function ModalHeader({
  clockControlType,
  rank,
}: {
  clockControlType: ClockControlType;
  rank?: number;
}) {
  return (
    <div className={styles.header}>
      <div className={styles.icon}>
        <ClockControlIcon type={clockControlType} />
      </div>

      <div className={styles.title}>
        {TIME_CONTROL[clockControlType]}&nbsp;·&nbsp;{rank}
      </div>
    </div>
  );
}
